import getCurrencyStorage from '../../../utils/numeric/getCurrencyStorage';
import getIntegerStorage from '../../../utils/numeric/getIntegerStorage';
import getNumberStorage from '../../../utils/numeric/getNumberStorage';
import { isCurrency, getCurrency, isInteger, isNumber } from './isNumeric';
export default function getNumericStorage(props, value) {
  if (isCurrency(props)) {
    return getCurrencyStorage(value, getCurrency(props));
  }
  if (isInteger(props)) {
    return getIntegerStorage(value);
  }
  if (isNumber(props)) {
    return getNumberStorage(value);
  }
  return '';
}